import { get } from '@/api'

/**
 * 获取城市列表
 */
export function getCityList() {
  return get('/config/city/list')
}

/**
 * 获取车辆品牌列表
 */
export function getBrandCarModeList() {
  return get('/config/brand/car-mode/list')
}
